var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSiteActivePin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.108,
    height: 71.633,
    viewBox: "0 0 54.108 71.633",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_4421",
    x: 0,
    y: 0,
    width: 54.108,
    height: 71.633,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4816",
    "data-name": "Group 4816",
    transform: "translate(17632 14683.634)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(-17623 -14677.634)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 13.721,
    cy: 13.721,
    r: 13.721,
    transform: "translate(4.364 4.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4421-2",
    "data-name": "Path 4421",
    d: "M18.054,0A18.054,18.054,0,0,0,0,18.054c0,9.971,18.054,35.579,18.054,35.579S36.108,28.025,36.108,18.054A18.054,18.054,0,0,0,18.054,0m0,30.965A12.911,12.911,0,1,1,30.965,18.054,12.911,12.911,0,0,1,18.054,30.965",
    transform: "translate(9 6)",
    fill: "#ea4335"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hospital",
    d: "M4.948,1.237A1.237,1.237,0,0,1,6.185,0h4.123a1.237,1.237,0,0,1,1.237,1.237V13.2H9.484V11.133a1.237,1.237,0,0,0-2.474,0V13.2H4.948ZM1.237,2.474H4.123V13.2H1.237A1.237,1.237,0,0,1,0,11.958V8.247H2.062a.412.412,0,1,0,0-.825H0V5.773H2.062a.412.412,0,1,0,0-.825H0V3.711A1.237,1.237,0,0,1,1.237,2.474Zm14.02,0a1.237,1.237,0,0,1,1.237,1.237V4.948H14.432a.412.412,0,0,0,0,.825h2.062V7.422H14.432a.412.412,0,0,0,0,.825h2.062v3.711A1.237,1.237,0,0,1,15.257,13.2H12.37V2.474ZM8.041,1.649a.414.414,0,0,0-.412.412V2.68H7.01a.414.414,0,0,0-.412.412V3.5a.414.414,0,0,0,.412.412h.619v.619a.414.414,0,0,0,.412.412h.412a.414.414,0,0,0,.412-.412V3.917h.619A.414.414,0,0,0,9.9,3.5V3.093a.414.414,0,0,0-.412-.412H8.865V2.062a.414.414,0,0,0-.412-.412Z",
    transform: "translate(-17613.193 -14666.483)",
    fill: "#ea4335"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSiteActivePin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Site-active-pin.e4d6e1b271e7ff36fdcbc2ed9617c4a1.svg";